import type { R2Index } from '../../layerstack/LayerStackLoader';
import { R2_BAND_SPEEDS, type BandSpec } from '../R2Renderer';
import { rtPath } from '../assets/registry';
import { landmarkBandSpec } from './landmark';

/**
 * Stage 1's background composition, far to near. The array order IS the z
 * order — R2Renderer.addBand appends to the band layer — and the landmark row
 * sits third, between the middle and near bands.
 *
 * The far band is pinned to y=0 rather than bottom-aligned: the bands are
 * opaque rectangles, and bottom-aligning all three left a 3 px background
 * stripe above the 537 px far band. Pinning covers the top instead and hides
 * the 3 px it loses under the two nearer bands. Every parallax band wraps by
 * mirroring so the wrap seam stops reading as a repeat.
 */
const BAND_SLUGS = ['01-stage1-far', '02-stage1-middle', '03-stage1-near'] as const;
const FAR_BAND_TOP_Y = 0;
const DEFAULT_BAND_SPEED = 1;

/**
 * 空フィル層の名前（manifest の layers[].name）。各バンドは空込みの不透明矩形と
 * して納品されており、そのまま積むと上端が水平段差になる。中景/近景の空フィルを
 * 非表示にすると構造物レイヤーの実アルファだけが残り、空は far 一枚が描く
 * 「統一一枚絵」合成になる — 視差もアートも無傷の根治。
 */
const MIDDLE_SKY_FILL_LAYER = 'depth-parallax';
const NEAR_SKY_FILL_LAYER = 'lane-backdrop';

function bandSpeed(index: number): number {
  return R2_BAND_SPEEDS[index] ?? DEFAULT_BAND_SPEED;
}

export function stageBandSpecs(index: R2Index): readonly BandSpec[] {
  return [
    { rungPath: rtPath(index, BAND_SLUGS[0]), speed: bandSpeed(0), y: FAR_BAND_TOP_Y, wrapMode: 'mirror' },
    { rungPath: rtPath(index, BAND_SLUGS[1]), speed: bandSpeed(1), wrapMode: 'mirror', hiddenLayerNames: [MIDDLE_SKY_FILL_LAYER] },
    landmarkBandSpec(index),
    { rungPath: rtPath(index, BAND_SLUGS[2]), speed: bandSpeed(2), wrapMode: 'mirror', hiddenLayerNames: [NEAR_SKY_FILL_LAYER] },
  ];
}
